var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM13.5 17.7115C13.5 18.4019 12.9404 18.9615 12.25 18.9615C11.5596 18.9615 11 18.4019 11 17.7115C11 17.0212 11.5596 16.4615 12.25 16.4615C12.9404 16.4615 13.5 17.0212 13.5 17.7115ZM12.3 6C10.4775 6 9 7.47746 9 9.3V9.4H11V9.3C11 8.58203 11.582 8 12.3 8C13.018 8 13.6 8.58203 13.6 9.3V9.78242C13.6 10.0858 13.408 10.3559 13.1215 10.4555C12.0309 10.8348 11.3 11.8629 11.3 13.0176V15H13.3V13.0176C13.3 12.7142 13.492 12.4441 13.7785 12.3445C14.8691 11.9652 15.6 10.9371 15.6 9.78242V9.3C15.6 7.47746 14.1225 6 12.3 6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/Faq.cfd0c5f7.svg";
export { ForwardRef as ReactComponent };